module.exports = __webpack_public_path__ + "static/media/mulher.b3ca9147.png";